import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "shadow-sm bg-gray-50 rounded-md border mt-8" }
const _hoisted_2 = {
  id: "header",
  class: "flex justify-center md:justify-between flex-col md:flex-row items-center px-5 py-2 border-b"
}
const _hoisted_3 = {
  key: 0,
  class: "flex items-center gap-4 h-[48px]"
}
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass(`py-4 w-full cursor-pointer capitalize text-base`)
}
const _hoisted_5 = {
  key: 1,
  class: "text-red-600 text-sm"
}
const _hoisted_6 = {
  key: 1,
  class: "flex items-center gap-4 h-[48px] w-1/2"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  key: 0,
  id: "content",
  class: "h-[300px] overflow-auto scroll-style bg-white"
}
const _hoisted_9 = {
  class: /*#__PURE__*/_normalizeClass(`flex items-center gap-5 border-b-2 border-b-gray-100 p-5 bg-white hover:bg-blue-50 cursor-pointer`)
}
const _hoisted_10 = { class: "flex items-center justify-between w-full flex-wrap gap-5" }
const _hoisted_11 = { class: "flex items-center gap-5" }
const _hoisted_12 = { class: "flex justify-center" }
const _hoisted_13 = { class: "flex flex-col" }
const _hoisted_14 = { class: "text-lg font-bold text-gray-800 mb-2 line-clamp-1" }
const _hoisted_15 = { class: "flex flex-wrap gap-3 md:divide-x divide-gray-500 text-gray-500 text-sm" }
const _hoisted_16 = { class: "text-sm capitalize" }
const _hoisted_17 = {
  key: 0,
  class: "py-8"
}
const _hoisted_18 = {
  key: 1,
  id: "content",
  class: "h-[300px] overflow-auto scroll-style bg-white"
}
const _hoisted_19 = { class: "h-[300px] flex justify-center items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_TagMaterials = _resolveComponent("TagMaterials")!
  const _component_Draggable = _resolveComponent("Draggable")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.data?.name)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("label", null, [
              _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t("labels.generic", {
                pt: `Plano ${_ctx.getMaterialTypePT(_ctx.data?.name)}`,
                en: `${_ctx.data?.name} Plan`,
              })), 1)
            ]),
            (_ctx.role === 'TEACHER')
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "btn-outline h-[32px] p-button-sm",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.redirectToPage()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", {
              pt: `Selecionar objetos`,
              en: `Choose objects`,
            })), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t("labels.generic", {
              pt: `Por favor adicionar ao menos um objeto a este plano!`,
              en: `Please add at least one object to this lesson plan!`,
            })), 1))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_Skeleton, { class: "w-1/2 border-round h-1rem" })
          ])),
      (_ctx.data?.name)
        ? (_openBlock(), _createElementBlock("h6", _hoisted_7, _toDisplayString(_ctx.data?.materials.length) + " " + _toDisplayString(_ctx.$t("labels.generic", {
            pt: `objeto${_ctx.data?.materials.length == 1 ? "" : "s"}`,
            en: `object${_ctx.data?.materials.length == 1 ? "" : "s"}`,
          })), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.data?.name)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_Draggable, {
            modelValue: _ctx.data.materials,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.materials) = $event)),
            itemKey: "index",
            onEnd: _ctx.onEnd,
            disabled: true
          }, {
            item: _withCtx(({ element }) => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_v_icon, {
                        name: _ctx.getIcon(element.file?.mimetype),
                        class: "text-h-primary-500",
                        scale: 1.3
                      }, null, 8, ["name", "scale"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("p", _hoisted_14, _toDisplayString(element.name), 1),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("labels.generic", {
                          pt: `Classificação: ${_ctx.getLearningGroupTypePT(
                            element.learningGroupType
                          )}`,
                          en: `Classification: ${element.learningGroupType} |`,
                        })), 1),
                        _createVNode(_component_TagMaterials, { material: element }, null, 8, ["material"])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "onEnd"]),
          (!_ctx.data?.materials || _ctx.data?.materials.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_EmptyData, {
                  data: !_ctx.data?.materials || _ctx.data?.materials.length === 0,
                  title: _ctx.emptyState.title,
                  label: _ctx.emptyState.description,
                  image: _ctx.emptyState.image,
                  imgSize: "h-32"
                }, null, 8, ["data", "title", "label", "image"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_Loader, {
              loader: _ctx.data?.name == ''
            }, null, 8, ["loader"])
          ])
        ]))
  ]))
}